<template>
  <div v-transfer-dom :data-transfer="transfer">
    <transition name="fade">
      <div :class="prefixCls+'-mask'" v-show="visible" @click.self="handleMaskClick"></div>
    </transition>
    <div :class="wrapClasses" @click="handleWrapClick">
      <transition name="scale" @after-leave="animationFinish">
        <div :class="classes" v-show="visible">
          <div class="message-box-content">
            <div :class="prefixCls+'-body'">
              <slot></slot>
            </div>
            <div :class="prefixCls+'-footer'">
              <slot name="footer">
                <button v-if="showCancel" type="button" class="cancel-btn" @click.stop="cancel">
                  {{cancelText}}
                </button>
                <button type="button" class="ok-btn" @click.stop="ok">
                  {{okText}}
                </button>
              </slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import TransferDom from '../../directives/transfer-dom'

  const prefixCls = 'nio-message-box';
  export default {
    name: "messageBox",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      maskClosable: {
        type: Boolean,
        default: true
      },
      transfer: {
        type: Boolean,
        default: true
      },
      okText: {
        type: String,
        default: 'OK'
      },
      cancelText: {
        type: String,
        default: 'CANCEL'
      },
      showCancel: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        prefixCls: prefixCls,
        visible: false,
        showWrap: false,
        buttonLoading: false
      }
    },
    directives: {
      TransferDom
    },
    computed: {
      wrapClasses() {
        return {
          [`${prefixCls}-wrapper`]: true,
          [`${prefixCls}-hidden`]: !this.showWrap,
          [`${this.className}`]: !!this.className //自定义类名
        }
      },
      classes() {
        return {
          [`${prefixCls}`]: true
        }


      },
    },
    methods: {
      handleMaskClick() {
        if (this.maskClosable) {
          this.close();
        }

      },
      ok() {
        if (this.loading) {
          this.buttonLoading = true;
        } else {
          this.close();
        }
        this.$emit('on-ok');

      },
      cancel() {
        this.close();
        this.$emit('on-cancel');
      },
      close() {
        this.visible = false;
        this.$emit('input', false);
      },
      handleWrapClick() {
        this.$emit('on-wrapper-click')
      },
      animationFinish() {
        this.$emit('on-messagebox-hidden')
      }
    },
    mounted() {
      this.$on('on-wrapper-click', this.handleMaskClick)
    },
    watch: {
      value: {
        handler(val) {
          this.visible = val;
        },
        immediate: true
      },
      visible: {
        handler(val) {
          if (!val) {
            this.timer = setTimeout(() => {
              this.showWrap = false;
            }, 300);
          } else {
            if (this.timer) clearTimeout(this.timer);
            this.showWrap = true;
          }
        },
        immediate: true
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/message-box/message-box.vue